/**
 * 大数据埋点系统
 **/
import store from '@/store/index';
import utils from '@/utils/common';
import SHA256 from '@/utils/sha1';
import config from '@/config/user.env';
// import extraModelNames from '@/bigData/extraModelNames.js'

class BigDataLog {
    constructor() {
        this.tokenApi = config.bigDataLogTokenUrl ? config.bigDataLogTokenUrl + '/api/1.0.1/getToken' : null;
        this.mainApi = config.bigDataLogUrl + '/api/2.0/send_main_message';
        this.detailApi = config.bigDataLogUrl + '/api/2.0/send_detail_message';
        // this.errorApi = config.bigDataLogUrl + '/api/2.0/send_error_message';
        this.moduleName = '';
        this.childModuleName = '';
        this.userName = '';
        this.token = '';
        this.expire = (new Date()).getTime();
        this.browserInfo = {};
        this.screenInfo = {};
    }

    init(moduleName, childModuleName) {
        this.moduleName = moduleName;
        this.childModuleName = childModuleName;
        this.browserInfo = this.getBrowserInfo();
        this.screenInfo = this.getScreenInfo();
    }
    checkToken() {
        if (!this.token || this.expire < (new Date()).getTime()) {
            return this.getToken();
        } else {
            return new Promise(resolve => {
                resolve();
            });
        }
    }
    // 获取 token
    getToken() {
        this.userName = store.state.user.userCode;
        return new Promise((resolve, reject) => {
            if (!this.tokenApi) {
                reject(new Error('tokenApi error'));
            }
            utils.ajax({
                url: this.tokenApi,
                data: {
                    appSecrect: config.bigDataLogAppSecrect,
                    appName: config.bigDataLogAppName,
                    userName: this.userName
                },
                success: (data) => {
                    data = JSON.parse(data);
                    if (data && data.data) {
                        this.token = data.data.token;
                        this.expire = data.data.expire;
                        resolve();
                    }
                }
            });
        });
    }
    getBrowserInfo() {
        const Sys = {
            platform: window.navigator.platform,
            userAgent: window.navigator.userAgent,
            language: window.navigator.language,
            appPlatform: window.navigator.appVersion,
            appVersion: window.navigator.buildID
        };
        const ua = window.navigator.userAgent.toLowerCase();
        const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        const m = ua.match(re);
        if (m[0] && m[1]) {
            Sys.appCodeName = m[1].replace(/version/, "'safari");
            Sys.appName = m[0];
        }
        return Sys;
    }
    getScreenInfo() {
        return {
            availWidth: window.screen.availWidth,
            availHeight: window.screen.availHeight,
            width: window.screen.width,
            height: window.screen.height,
            colorDepth: window.screen.colorDepth,
            pixelDepth: window.screen.pixelDepth
        };
    }
    getNetworkType() {
        let netType = 'wifi';
        if (window.navigator.connection && window.navigator.connection.effectiveType) {
            netType = navigator.connection.effectiveType;
        };
        return netType;
    }
    getMainMessage() {
        return {
            userName: this.userName,
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo
        };
    }
    getDetailMessage(modelInfo = {}) {
        return {
            userName: this.userName,
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo,
            ...modelInfo
        };
    }
    getErrorMessage(errInfo = {}) {
        return {
            userName: this.userName,
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            netType: this.getNetworkType(),
            errContent: errInfo.Content,
            errType: errInfo.Type
        };
    }
    sendMainMessage() {
        // 必填信息不为空才提交
        if (!this.moduleName) {
            return false;
        }
        this.checkToken().then(() => {
            utils.ajax({
                url: this.mainApi,
                data: {
                    token: this.token,
                    sign: SHA256(config.bigDataLogAppName + this.expire + config.bigDataLogAppSecrect),
                    appName: config.bigDataLogAppName,
                    time: this.expire,
                    topicName: 'request_data_main_log',
                    message: JSON.stringify(this.getMainMessage())
                },
                type: 'POST',
                success: function(data) {}
            });
        });
    }
    sendDetailMessage(modelInfo = {}) {
        // 必填信息不为空才提交
        if (!this.moduleName || !modelInfo.model_name1) {
            return false;
        }
        this.checkToken().then(() => {
            utils.ajax({
                url: this.detailApi,
                data: {
                    token: this.token,
                    sign: SHA256(config.bigDataLogAppName + this.expire + config.bigDataLogAppSecrect),
                    appName: config.bigDataLogAppName,
                    time: this.expire,
                    topicName: 'request_data_detail_log',
                    message: JSON.stringify(this.getDetailMessage(modelInfo))
                },
                type: 'POST',
                success: function(data) {}
            });
        });
    }
    sendErrorMessage(errInfo = {}) {
        // // 必填信息不为空才提交
        // if (!this.moduleName || !errInfo.errContent || !errInfo.errType) {
        //     return false;
        // }
        // this.checkToken().then(() => {
        //     utils.ajax({
        //         url: this.errorApi,
        //         data: {
        //             token: this.token,
        //             sign: SHA256(config.bigDataLogAppName + this.expire + config.bigDataLogAppSecrect),
        //             appName: config.bigDataLogAppName,
        //             time: this.expire,
        //             topicName: 'request_data_error_log',
        //             message: JSON.stringify(this.getErrorMessage(errInfo))
        //         },
        //         type: 'POST',
        //         success: function(data) {}
        //     });
        // });
    }
    sendDetailMessageByKey(key) {
        let names = window.bigDataConfig[key];
        // 匹配不到埋点数据取消请求
        if (!names) {
            return false;
        }
        const params = {};
        if (typeof names === 'string') {
            names = names.split(',');
        }
        names.forEach((name, index) => {
            params['model_name' + (index + 1)] = name;
        });
        this.sendDetailMessage(params);
    }
    sendDetailMessageByNames(names) {
        if (!names) {
            return false
        }
        const params = {}
        if (typeof names === 'string') {
            names = names.split(',')
        }
        names.forEach((name, index) => {
            params['model_name' + (index + 1)] = name
        })
        this.sendDetailMessage(params)
    }
    sendDetailMessageByRoute(route) {
        // // 在额外的页面埋点配置中找到配置项
        // if (route.name && extraModelNames[route.name]) {
        //     this.sendDetailMessageByNames(extraModelNames[route.name])
        //     return false
        // }
        const modelInfo = this.getModelInfoByRoute(route)
        if (Object.keys(modelInfo).length) {
            this.sendDetailMessage(modelInfo)
        }
    }
    getModelInfoByRoute(route) {
        const resources = store.state.authority
        const infoMap = new Map();
        const modelInfo = {}
        if (resources && resources.length) {
            resources.forEach((item) => {
                if (item.frontUrl === route.path) {
                    infoMap.set('model_name1', item.resourceName);
                    return false;
                }
                if (item.subResources && item.subResources.length) {
                    item.subResources.forEach((subItem) => {
                        if (subItem.frontUrl === route.path) {
                            infoMap.set('model_name1', item.resourceName);
                            infoMap.set('model_name2', subItem.resourceName);
                            return false;
                        }
                        if (subItem.subResources) {
                            subItem.subResources.forEach((subItemSon) => {
                                if (subItemSon.frontUrl === route.path) {
                                    infoMap.set('model_name1', item.resourceName);
                                    infoMap.set('model_name2', subItem.resourceName);
                                    infoMap.set('model_name3', subItemSon.resourceName);
                                    return false;
                                }
                            });
                        }
                    });
                }
            });
            for (const [key, value] of infoMap) {
                modelInfo[key] = value;
            }
        }
        return modelInfo;
    }
};
export default new BigDataLog();
